import { Head } from "features/misc";
import { useArtist } from "features/reviewable";
import { ArtistReview, ArtistReviewForm } from "features/reviews";
import { useReview } from "features/reviews/api/useReview";
import { useParams } from "react-router-dom";

function EditArtistReview() {
  const { artistId, reviewedByUserId } = useParams() as {
    artistId: string;
    reviewedByUserId: string;
  };
  const { data: artist } = useArtist(artistId);
  const { data: review, isLoading } = useReview(
    "ARTIST",
    artistId,
    reviewedByUserId
  );

  return review && !isLoading ? (
    <>
      <Head title={`Edit Review For ${artist?.name}`} />

      <ArtistReviewForm
        artist={artist}
        artistId={artistId}
        review={review ? (review as ArtistReview) : undefined}
      />
    </>
  ) : (
    <div />
  );
}

export { EditArtistReview };
